<template>
  <Wrapper
    id="section-hover-frame"
    :position="sectionHover.position" 
    v-show="!preview && renderTools && sectionHover.id && (sectionHover.id != sectionActive.id || (sectionHover.id == sectionActive.id && cellActive.id)) && 
    !['reheight_widget', 'remargin_widget', 'sort_widget', 'reheight_grid', 'remargin_grid', 'reheight_component'].includes(mode)
    "
    :class="{ 'top': !oversection || !isFirstIndex, 'bottom': oversection && isFirstIndex }"
    @click="click"
    style="cursor: pointer;"
  >
    <!-- <pre>{{ sectionHover }}</pre> -->

    <FloatframeHover class="text-center lbl-name" :lv="dt.lv">{{
      sectionComponent && sectionComponent.type === 'SLIDE_SECTION' ? 'Slide' : $t('engine.floatframeTool.floatframeHover.section.lblSection', languageEngine)
    }}</FloatframeHover>

    <template>
      <AddSection class="add-section top" v-if="sectionHover.id != 'empty_section' && detectDevice == 'desktop' && !isExamplePage">
        <div class="center-hv w-100 d-flex justify-content-center">
          <div class="d-flex justify-content-center icon-section-wrapper">
            <div class="icon-hover-label btn-hover" @click.stop.prevent="addSection('up', sectionHover.id)">
              <span class="text-white icon-wrapper">
                <i class="fas fa-plus"></i>
              </span>
              <span class="icon-label">
                  {{ $t('engine.floatframeTool.floatframeHover.section.btnAddSection', languageEngine) }}
              </span>
            </div>
          </div>
        </div>  
      </AddSection>
      <AddSection
        v-if="!isSectionPage && sectionHover.id != 'empty_section' && detectDevice == 'desktop'"
        class="add-section bottom"
      >
        <div class="center-hv w-100 d-flex justify-content-center">
          <div class="d-flex justify-content-center icon-section-wrapper">
            <div class="icon-hover-label btn-hover" @click.stop.prevent="addSection('down', sectionHover.id)">
              <span class="text-white icon-wrapper">
                <i class="fas fa-plus"></i>
              </span>
              <span class="icon-label">
                  {{ $t('engine.floatframeTool.floatframeHover.section.btnAddSection', languageEngine) }}
              </span>
            </div>
          </div>
        </div>
      </AddSection>
    </template>

    <!-- <FloatframeHeaderHover>{{ sectionHover.name }} </FloatframeHeaderHover> -->
    <!-- <pre>{{ sectionHover }}</pre> -->
    <!-- <FloatframeHover v-else>{{ sectionHover.name }} </FloatframeHover> -->
  </Wrapper>
</template>
<script>
import {
  //   FloatframeHeaderHover,
  //   SectionName,
  AddSection,
  FloatframeHover,
  Wrapper,
} from "@components/tool/FloatFrameHover.styled.js";
import { mapGetters } from "vuex";
import { SECTION_TYPE_NONE_SETTING } from "@model/components/componentMeta.model";

export default {
  components: {
    // SectionName,
    // FloatframeHeaderHover,
    AddSection,
    FloatframeHover,
    Wrapper,
  },
  data() {
    return {
      positionTool: "top",
      topElementPosition: 0,
    }
  },
  computed: {
    ...mapGetters({
      detectDevice: "detectDevice",
      components: "designIframe/metadata/components",
      CONTENT_CONTAINER: "designIframe/metadata/CONTENT_CONTAINER",
      preview: "designIframe/preview",
      renderTools: "designIframe/frame/renderTools",
      sectionHover: "designIframe/frame/sectionHover",
      sectionActive: "designIframe/frame/sectionActive",
      mode: "designIframe/mode",
      scrollPosition: "scrollPosition",
      isExamplePage: "designIframe/page/isExamplePage",
      siteComponents: "designIframe/metadata/siteComponents",
      sitePageID: "designIframe/metadata/sitePageID",
      languageEngine: "designIframe/userPreference/languageEngine",
      cellActive: "designIframe/frame/cellActive",
      limit: "designIframe/page/limit",
    }),
    sections() {
      return this.CONTENT_CONTAINER.componentsID;
    },
    dt() {
      return {
        name: "",
        id: undefined,
        lv: 0,
        ...this.sectionHover,
      };
    },
    isSectionPage() {
      return this.sectionHover.id === "SECTION_PAGE";
    },
    isOverScroll() {
      this.scrollPosition;
      const diff = this.scrollPosition - this.topElementPosition;
      if (diff >= 0) {
        return true;
      } else {
        return false;
      }
    },
    indexSection() {
      return this.CONTENT_CONTAINER.componentsID.indexOf(this.sectionHover.id);
    },
    isFirstIndex() {
      return this.indexSection == 0;
    },
    sectionComponent() {
      return this.sectionHover.id && this.components[this.sectionHover.id]
    },
    getMainPage() {
      const mainPageID =
        this.siteComponents &&
        this.siteComponents.MAIN_PAGE &&
        this.siteComponents.MAIN_PAGE.properties &&
        this.siteComponents.MAIN_PAGE.properties.pageID;
      return mainPageID;
    },
    oversection() {
      return (
        this.sitePageID == this.getMainPage && this.HEADER.style.isEnableOverSection
      );
    },
    HEADER() {
      return this.siteComponents.HEADER;
    },
  },
  methods: {
    addSection(direction, section_id) {
      const sectionCountInPage = this.sections.length;
      if(!this.limit.section || sectionCountInPage < this.limit.section) {
        this.$store.commit("designIframe/setStatePath", {
          value: {
            sectionID: section_id,
            direction,
          },
          path: "/component/addComponent/section",
        });
        this.$store.dispatch("design/setMode", {
          mode: "add_section",
        });
      }
      else {
        this.$store.dispatch("design/setModal", {
          name: "modal-alert-limit-section",
          payload: {},
        });
      }
      this.$store.dispatch("designIframe/frame/setSectionActive", {
        component_id: section_id,
        name: section_id,
      });
      let noneSetting = false;
      SECTION_TYPE_NONE_SETTING.find((type) => {
        Object.entries(this.components).forEach((item) => {
          if (type === item[1].type && item[1].id === section_id) {
            noneSetting = true;
          }
        })
      });
      if (noneSetting) {
        this.$store.dispatch("design/component/elActive", {});
      } else {
        this.$store.dispatch("design/component/elActive", {
          elementID: ["component", section_id],
        });
      }
      this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});
      this.$store.dispatch("designIframe/frame/setSlideContainerHover", {});
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
      this.$store.dispatch("designIframe/frame/setCellActive", {});
      this.$store.dispatch("designIframe/frame/setCellHover", {});
      this.$store.dispatch("designIframe/frame/setWidgetActive", {});
      this.$store.dispatch("designIframe/frame/setWidgetHover", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
    },
    click(e) {
      e.stopPropagation();
      var compID = this.sectionHover.id;
      this.$store.dispatch("design/setMode", {});

      this.$store.dispatch("designIframe/frame/setSectionActive", {
        component_id: compID,
        name: this.sectionHover.id,
      });
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});
      this.$store.dispatch("designIframe/frame/setCellActive", {});
      this.$store.dispatch("designIframe/frame/setCellHover", {});
      this.$store.dispatch("designIframe/frame/setWidgetActive", {});
      this.$store.dispatch("designIframe/frame/setWidgetHover", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
      this.$store.dispatch("designIframe/frame/setParentWidgetActive", {});
      let noneSetting = false;
      SECTION_TYPE_NONE_SETTING.find((type) => {
        Object.entries(this.components).forEach((item) => {
          if (type === item[1].type && item[1].id === compID) {
            noneSetting = true;
          }
        });
      });
      if (noneSetting) {
        this.$store.dispatch("design/component/elActive", {});
      } else {
        this.$store.dispatch("design/component/elActive", {
          elementID: ["component", compID],
        });
      }
    },
    //   [this.sectionHover.id.length - 1]
    // addSection(direction) {
    //   this.$store.commit("designIframe/setStatePath", {
    //     value: {
    //       sectionID: this.sectionHover.id,
    //       direction,
    //     },
    //     path: "/component/addComponent/section",
    //   });
    //   this.$store.dispatch("design/setMode", {
    //     mode: "add_section",
    //   });
    // },
    // hover(e) {
    //   e.stopPropagation();
    //   this.$store.dispatch("designIframe/frame/setSectionHover", {
    //     component_id: this.sectionHover.id,
    //     name: this.sectionHover.name,
    //   });
    // },
  },
  watch: {
    sectionHover: {
      deep: true,
      handler() {
        const element = document.getElementById("section-hover-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
          })
        }
      }
    }
  },
};
</script>
